//# sourceMappingURL=item.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/list/item.interface.js
// module id = 1175
// module chunks = 4